import React from "react";

const detailSections = [
  ["Overview", "overview"],
  ["My role", "role"],
  ["What I learned", "learned"],
  ["Challenges", "challenges"],
  ["What I would improve", "improvements"],
];

const ProjectDetailWindow = ({ project, navigate }) => {
  const screenshots = project.details?.screenshots || [];

  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="win-sunken-thin m-2 flex items-center justify-between gap-2 px-2 py-1 text-xs">
        <span className="flex items-center gap-2">
          <span aria-hidden="true">📄</span>
          C:\JAKOB\PROJECTS\{project.slug}.txt
        </span>
        <button type="button" onClick={() => navigate("projects")} className="win-btn win-focus-dotted px-2 py-0.5 text-[11px] font-bold">
          ◂ Back to projects
        </button>
      </div>

      <div className="flex-1 overflow-auto px-3 pb-3">
        <div className="flex flex-wrap gap-2 text-[11px] font-bold uppercase tracking-wide">
          <span className="win-raised px-2 py-1">{project.category}</span>
          <span className="win-raised px-2 py-1 text-win-navy">{project.year}</span>
        </div>

        <h1 className="mt-3 text-2xl font-black leading-tight sm:text-3xl">{project.title}</h1>
        <p className="mt-3 max-w-3xl text-sm leading-6">{project.description}</p>

        <div className="mt-4 flex flex-wrap gap-2">
          {project.websiteLink && (
            <a href={project.websiteLink} target="_blank" rel="noopener noreferrer" className="win-btn win-focus-dotted flex items-center px-3 py-1.5 text-xs font-bold">
              🌐 View live
            </a>
          )}
          {project.githubLink && (
            <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="win-btn win-focus-dotted flex items-center px-3 py-1.5 text-xs font-bold">
              💾 Source code
            </a>
          )}
          {project.accessNote && (
            <div className="win-sunken-thin flex items-center px-3 py-1.5 text-xs">
              <span className="mr-1.5 font-bold text-win-navy">🔒 Private:</span>
              {project.accessNote}
            </div>
          )}
        </div>

        <div className="win-sunken-thin mt-4 p-3">
          <p className="text-[11px] font-bold uppercase tracking-wide text-win-navy">Stack</p>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {project.stack.map((item) => (
              <span key={item} className="win-raised px-2 py-1 text-[11px] font-bold">
                {item}
              </span>
            ))}
          </div>
          <p className="mt-3 border-l-4 border-win-navy pl-3 text-xs leading-5">{project.impact}</p>
        </div>

        <div className="mt-4 grid gap-3 lg:grid-cols-2">
          {detailSections.map(([label, key]) => (
            project.details?.[key] && (
              <article key={key} className="win-raised p-3">
                <h2 className="text-base font-black">{label}</h2>
                <p className="mt-2 text-sm leading-6">{project.details[key]}</p>
              </article>
            )
          ))}
        </div>

        {screenshots.length > 0 && (
          <div className="mt-4">
            <p className="text-[11px] font-bold uppercase tracking-wide text-win-navy">Screenshots</p>
            <div className="mt-2 grid gap-3 md:grid-cols-2">
              {screenshots.map((screenshot) => (
                <figure key={screenshot.src} className="win-sunken-thin p-2">
                  <img src={screenshot.src} alt={screenshot.alt} className="h-auto w-full border border-[#808080]" />
                  {screenshot.caption && (
                    <figcaption className="mt-2 px-1 text-xs leading-5 text-[#404040]">{screenshot.caption}</figcaption>
                  )}
                </figure>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectDetailWindow;
